import styled from "styled-components";
import { rotatingShineAnimation } from "../../../TutorialV2/animations";
import { ButtonShine } from "../../../TutorialV2/lib/Step3/styles";

export const LoyaltyButtonShine = styled(ButtonShine)`
	width: 19.875em;
	height: 19.875em;
`;

export const RedeemWord = styled.span`
	position: relative;
	display: inline-block;
	z-index: -1;
`;

export const RedeemShine = styled.img`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 6.8em;
	height: 6.8em;
	font-size: 10px;
	opacity: 0.8;
	z-index: -1;
	pointer-events: none;
	${rotatingShineAnimation}
`;

export const RedeemText = styled.span`
	position: relative;
	z-index: 1;
`;
